(() => {
  const selector = '.wm-bundle-total';
  let refreshTimer;
  const refresh = () => {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(() => {
      if (document.querySelector(selector) && typeof window.bndlr?.updateCartDiscounts === 'function') {
        window.bndlr.updateCartDiscounts();
      }
    }, 100);
  };

  const initialise = () => {
    new MutationObserver(records => {
      const cartWasRendered = records.some(record => Array.from(record.addedNodes).some(node =>
        node.nodeType === Node.ELEMENT_NODE && (node.matches(selector) || node.querySelector(selector))
      ));
      if (cartWasRendered) refresh();
    }).observe(document.body, { childList: true, subtree: true });
    refresh();
  };

  document.addEventListener('bundler:loaded', refresh);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
})();
